import { AuthStorage, getUser, PluggableStorage, PrefixKeyStrategy } from '@frontend/auth-helpers';
import { sentry } from '@frontend/tracking';

function getStore() {
  const userId = getUser()?.userID ?? 'default';
  return new PluggableStorage(new PrefixKeyStrategy(`${userId}.auth_perf_trace`));
}

type TimeToRedirectData = {
  timeSinceLoad: number;
  timeSinceDOMContentLoaded: number;
  timestamp: number;
  expGroup: string;
};

// Store the time to redirect to auth because we're about to have a top level page nav so network requests might get cancelled
export function storeTimeToRedirectToAuth(expGroup?: string) {
  // if we're in NWX and redirecting to auth.weave, log the time from page load to now
  const timeSinceLoad = Math.round(Date.now() - window.performance.timeOrigin);
  const timeSinceDOMContentLoaded = Math.round(Date.now() - window.performance.timing.domContentLoadedEventEnd);
  getStore().setItem<TimeToRedirectData>(AuthStorage.time_to_auth_redirect, {
    timeSinceLoad,
    timeSinceDOMContentLoaded,
    timestamp: Date.now(),
    expGroup: expGroup || '',
  });
}

// grab values from LS and logs them
export function logTimeToRedirectToAuth() {
  const store = getStore();
  const data = store.getItem<TimeToRedirectData, null>(AuthStorage.time_to_auth_redirect);
  if (data) {
    const transaction = sentry.instance.startInactiveSpan({
      name: `auth_redirect`,
      forceTransaction: true, // force it as a separate transaction, not a part of whatever trace/transaction is currently active
      op: 'auth.redirect',
      startTime: data.timestamp - data.timeSinceLoad,
      attributes: {
        expGroup: data.expGroup,
      },
    });
    transaction.end(data.timestamp);
    store.removeItem(AuthStorage.time_to_auth_redirect);
  }
}
